<div *ngIf="href" class="nav-item d-flex align-items-center justify-content-center" role="menuitem">
  <a class="nav-link" [href]="href">
    <ng-container *ngTemplateOutlet="contentProjection"></ng-container>
  </a>
</div>

<div *ngIf="!href" class="nav-item d-flex align-items-center justify-content-center" role="menuitem">
  <ng-container *ngTemplateOutlet="contentProjection"></ng-container>
</div>

<ng-template #contentProjection>
  <ng-content></ng-content>
</ng-template>
